/** @format */

import React, { Component } from 'react';
import SaleTableHead from './SaleTableHead/SaleTableHead';
import SaleTableTot from './SaleTableTot/SaleTableTot';
import { Table, Segment, Header, Icon, Divider } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('SalesStore', 'RequestsStore')
@observer
class SaleTable extends Component {
  renderSaleProducts = () => {
    const { SalesStore, RequestsStore } = this.props;
    let saleProducts = SalesStore.currentSale.data.items;
    let saleProductsKey = Object.keys(saleProducts);
    let renderSaleProducts = null;
    if (
      RequestsStore.progress === 'contrattazione vendita' ||
      RequestsStore.progress === 'completata con vendita'
    ) {
      renderSaleProducts = saleProductsKey.map(key => {
        return (
          <Table.Row key={key}>
            <Table.Cell>
              <small>{saleProducts[key].data.name}</small>
            </Table.Cell>
            <Table.Cell>
              <small>{saleProducts[key].data.internalCode}</small>
              <br />
            </Table.Cell>
            <Table.Cell>
              <small>{saleProducts[key].data.position}</small>
              <br />
            </Table.Cell>
            <Table.Cell>
              <small>{saleProducts[key].data.price}€</small>
              <br />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    return renderSaleProducts;
  };
  render() {
    return (
      <Segment>
        <Header as="h3">
          <small>
            <Icon name="cart" />
          </small>
          Ordine
        </Header>
        <Divider fitted />
        <Table compact basic="very" celled className="no-margin-top">
          <Table.Body>
            <SaleTableHead />
            {this.renderSaleProducts()}
            <SaleTableTot />
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default SaleTable;
